import { GetBlogPostsResponse, SITES } from '@klokgroep/sanity';

export const getOptionsFromBlogPosts = (
  blogPosts: GetBlogPostsResponse[] = [],
  label: 'categories' | 'specialisms' | 'siteId',
  selected: string[]
) => {
  if (label === 'siteId') {
    const items = blogPosts.map((item) => ({
      checked: selected.includes(item[label] || ''),
      id: item[label],
      label: SITES.find(({ siteId }) => siteId === item[label])?.companyName,
    }));

    const uniqueItems = [...new Map(items.map((item) => [item['id'], item])).values()];

    return uniqueItems;
  }

  if (label === 'categories') {
    const items = blogPosts
      .flatMap((item) =>
        item?.categories?.map((category) => ({
          checked: selected.includes(category?.slug?.current || ''),
          id: category?.slug?.current || '',
          label: category?.name || '',
        }))
      )
      .filter((item): item is { label: string; id: string; checked: boolean } => !!item?.label && !!item?.id);

    const uniqueItems = [...new Map(items.map((item) => [item['id'], item])).values()];

    return uniqueItems;
  }

  if (label === 'specialisms') {
    const items = blogPosts
      .flatMap((item) =>
        item?.specialisms?.map((specialism) => ({
          checked: selected.includes(specialism?.slug?.current || ''),
          id: specialism?.slug?.current || '',
          label: specialism?.name || '',
        }))
      )
      .filter((item): item is { label: string; id: string; checked: boolean } => !!item?.label && !!item?.id);

    const uniqueItems = [...new Map(items.map((item) => [item['id'], item])).values()];

    return uniqueItems;
  }

  return [];
};
